import { SVGProps } from "react";

const MostImportant = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={14}
    height={11}
    viewBox="0 0 14 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 4.85714L6.78571 1L12.5714 4.85714"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 10.0002L6.78571 6.14307L12.5714 10.0002"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default MostImportant;
